<div class="p-6">
    <div class="flex items-start gap-3 mb-4">
        <div class="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-blue-50">
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5 text-blue-600">download</mat-icon>
        </div>
        <div>
            <h2 class="text-base font-semibold text-slate-900">{{ 'obligations.exportTitle' | translate }}</h2>
            <p class="text-sm text-slate-500 mt-0.5">{{ 'obligations.exportBody' | translate }}</p>
        </div>
    </div>

    <div class="space-y-2">
        <!-- Current page -->
        <button type="button"
                class="w-full text-left p-3.5 rounded-xl border border-slate-200 hover:border-blue-600 hover:bg-blue-50/40 transition-colors flex items-center justify-between gap-3"
                (click)="choose('view')">
            <span>
                <span class="block text-sm font-medium text-slate-900">
                    {{ 'obligations.exportScopeView' | translate }}
                </span>
                <span class="block text-xs text-slate-500 mt-0.5">
                    {{ 'obligations.exportScopeViewHint' | translate: { count: data.viewCount } }}
                </span>
            </span>
            <mat-icon class="!w-5 !h-5 !text-[20px] text-slate-400 shrink-0">chevron_right</mat-icon>
        </button>

        <!-- Everything matching the filters -->
        <button type="button"
                class="w-full text-left p-3.5 rounded-xl border border-slate-200 hover:border-blue-600 hover:bg-blue-50/40 transition-colors flex items-center justify-between gap-3"
                (click)="choose('all')">
            <span>
                <span class="block text-sm font-medium text-slate-900">
                    {{ (data.isFiltered ? 'obligations.exportScopeAllFiltered' : 'obligations.exportScopeAll') | translate }}
                </span>
                <span class="block text-xs text-slate-500 mt-0.5">
                    {{ 'obligations.exportScopeAllHint' | translate: { count: data.totalCount } }}
                </span>
                @if (exceedsLimit()) {
                <span class="inline-flex items-center gap-1 text-xs text-amber-700 font-medium mt-1">
                    <mat-icon class="!w-3.5 !h-3.5 !text-[14px]">warning_amber</mat-icon>
                    {{ 'obligations.exportTruncatedWarning' | translate: { exported: exportedIfAll(), total: data.totalCount } }}
                </span>
                }
            </span>
            <mat-icon class="!w-5 !h-5 !text-[20px] text-slate-400 shrink-0">chevron_right</mat-icon>
        </button>
    </div>

    <div class="flex justify-end mt-5 pt-4 border-t border-slate-100">
        <jjames-button variant="ghost" (clicked)="onCancel()">{{ 'common.cancel' | translate }}</jjames-button>
    </div>
</div>
